// Copyright (C) Siemens AG 2026. All rights reserved. Confidential

import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, RouterOutlet } from '@angular/router';



@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppComponent implements OnInit {
  title = 'SIMATIC PCS neo subscription management';

  constructor( private readonly translate: TranslateService, private readonly router: Router
  ) {
    translate.setDefaultLang('en');
    translate.use('en');
  }

  ngOnInit() {
  
    
  

  }
}